import React, { useEffect, useState } from "react";
import { Route, Routes, useParams } from "react-router-dom";
import Pararesults from "./report";
import Page from "./report2";
import Btn from "./btn";

function ReportWrapper() {
  const { id } = useParams();

  const defaultStyle = {
    logo: "/paralogo.jpg",
    primaryColor: "#724e9e",
    secondaryColor: "#4180b8",
  };

  const [reportStyle, setReportStyle] = useState(defaultStyle);
  const [primaryColor, setPrimaryColor] = useState(defaultStyle.primaryColor);
  const [secondaryColor, setSecondaryColor] = useState(defaultStyle.secondaryColor);
  const [logo, setLogo] = useState("/blank.png");
  const [styleName, setStyleName] = useState("YourGutMap");
  const [header, setHeader] = useState();
  const [footer, setFooter] = useState();

  const lightenColor = (color, percent) => {
    const num = parseInt(color.replace("#", ""), 16);
    const amt = Math.round(2.55 * percent);
    const R = (num >> 16) + amt;
    const G = ((num >> 8) & 0xff) + amt;
    const B = (num & 0xff) + amt;

    return (
      "#" +
      (
        0x1000000 +
        (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
        (G < 255 ? (G < 1 ? 0 : G) : 255) * 0x100 +
        (B < 255 ? (B < 1 ? 0 : B) : 255)
      )
        .toString(16)
        .slice(1)
    );
  };

  useEffect(() => {
    const lightColor = lightenColor(primaryColor, 40);
    setReportStyle({
      header: header || "/blank.png",
      footer: footer || "/blank.png",
      logo: logo,
      primaryColor: lightColor,
      mainColor: primaryColor,
      secondaryColor: secondaryColor,
      fontColor: primaryColor,
      styleName: styleName,
    });
  }, [primaryColor, secondaryColor, logo, header, footer]);

  useEffect(() => {
    const fetchReportStyle = async () => {
      try {
        const response = await fetch(
          "https://yourgutmap-food-sensitivity-423a2af84621.herokuapp.com/getReportStyleByKit",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ kitId: id }),
          }
        );

        const result = await response.json();

        if (response.ok && result.style) {
          setPrimaryColor(result.style.primaryColor);
          setSecondaryColor(result.style.secondaryColor);
          setLogo(result.style.imageBase64);
          setStyleName(result.style.styleName);
          setHeader(result.style.header);
          setFooter(result.style.footer);
        }
      } catch (error) {
        console.error("Error fetching report style:", error);
      }
    };

    if (id) fetchReportStyle();
  }, [id]);

  return (
    <Routes>
      <Route path="parasitology" element={<Pararesults myReportStyle={reportStyle} />} />
      <Route path="candida" element={<Page myReportStyle={reportStyle} />} />
      <Route path="" element={<Btn myReportStyle={reportStyle} />} />
    </Routes>
  );
}

export default ReportWrapper;
